// src/gatsby-theme-docz/components/Logo/index.js
import React from 'react'
import logoLight from './logo.svg'
import logoDark from './logo-dark.svg';

import {useThemeUI} from 'theme-ui'
import {Link} from "gatsby";

export const Logo = () => {
    const {colorMode} = useThemeUI();

    return (
        <Link to="/">
            <img src={colorMode === 'dark' ? logoDark : logoLight} alt="CitNOW API Documentation"
                 style={{maxWidth: '70%', marginBottom: 16}}/>
        </Link>
    )
}
